import {
  breadcrumbsDataType,
  REMOVE_BREADCRUMBS,
  SET_BREADCRUMBS,
} from "../constants";

const initialState: breadcrumbsDataType = null;

const breadcrumbs = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_BREADCRUMBS:
      return payload;
    case REMOVE_BREADCRUMBS:
      return initialState;
    default:
      return state;
  }
};

export default breadcrumbs;
